(() => {
  const q = s => document.querySelector(s);
  const qa = s => [...document.querySelectorAll(s)];
  const body = q('[data-cart-body]');

  const polish = () => {
    if (!body) return;
    const p = body.firstElementChild;
    if (body.children.length === 1 && p?.matches('p.muted') && /bag is empty/i.test(p.textContent || '')) {
      const d = document.createElement('div');
      d.className = 'mm-empty-bag';
      d.innerHTML = '<span>00 / ITEMS</span><p>YOUR BAG IS EMPTY.</p><a href="/collections/all">SHOP ALL →</a>';
      body.replaceChildren(d);
    }
  };

  if (body && 'MutationObserver' in window) {
    new MutationObserver(polish).observe(body, { childList: true });
    polish();
  }

  // Failsafe: keep the bag control usable even if another cart script misses its binding.
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-cart-open]');
    if (!trigger) return;
    const drawer = q('[data-cart-drawer]');
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mm-overlay-open');
  });

  // Back/forward cache repair: re-sync only the visible count on restore without touching click bindings.
  window.addEventListener('pageshow', async e => {
    if (!e.persisted) return;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const res = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!res.ok) return;
      const cart = await res.json();
      qa('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    } catch (_) {}
  });
})();